var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBulkEdit = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.648 13.159h-3.75a.94.94 0 0 1-.937-.938V1.91A.94.94 0 0 1 1.898.97h6.643a.94.94 0 0 1 .663.275L11 3.04a.94.94 0 0 1 .274.663V5.66M6.117 4.252 7.523 5.66 6.117 7.065M4.242 4.252 2.836 5.66l1.406 1.406m10.394 2.73-4.77 4.767-2.343.47.469-2.345 4.77-4.769a1.32 1.32 0 0 1 1.869 0l.005.006a1.323 1.323 0 0 1 0 1.872"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.648 13.159h-3.75a.94.94 0 0 1-.937-.938V1.91A.94.94 0 0 1 1.898.97h6.643a.94.94 0 0 1 .663.275L11 3.04a.94.94 0 0 1 .274.663V5.66M6.117 4.252 7.523 5.66 6.117 7.065M4.242 4.252 2.836 5.66l1.406 1.406m10.394 2.73-4.77 4.767-2.343.47.469-2.345 4.77-4.769a1.32 1.32 0 0 1 1.869 0l.005.006a1.323 1.323 0 0 1 0 1.872"
  }));
});
export default SvgIconBulkEdit;
export const raw = __webpack_public_path__ + "static/media/IconBulkEdit.5058d519ac754fe46f233875e2ebb370.svg";